var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kryptium-button ",class:_vm.color},[_c('div',{staticClass:"overlay",class:{'fade-effect':_vm.showBlinkClass}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.betInfo.displayedText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }